// Standard India-market size charts. These are approximate references — actual
// fit varies by brand, which is what BIS Size Match is for. Footwear is best
// chosen by FOOT LENGTH (measure heel to toe, standing, on paper).

export const GENDERS = [
  { v: "men", label: "Men" },
  { v: "women", label: "Women" },
  { v: "kids", label: "Kids" },
];

export const FOOTWEAR = {
  men: {
    columns: ["UK", "EU", "US", "Foot length (cm)"],
    rows: [
      ["6", "39", "7", "24.1"],
      ["7", "41", "8", "24.9"],
      ["8", "42", "9", "25.7"],
      ["9", "43", "10", "26.5"],
      ["10", "44", "11", "27.3"],
      ["11", "45", "12", "28.1"],
      ["12", "46", "13", "29.0"],
    ],
  },
  women: {
    columns: ["UK", "EU", "US", "Foot length (cm)"],
    rows: [
      ["3", "36", "5", "21.6"],
      ["4", "37", "6", "22.4"],
      ["5", "38", "7", "23.2"],
      ["6", "39", "8", "24.0"],
      ["7", "40", "9", "24.8"],
      ["8", "41", "10", "25.6"],
    ],
  },
  kids: {
    columns: ["UK", "EU", "Foot length (cm)", "Approx age"],
    rows: [
      ["6", "23", "14.2", "18–24 m"],
      ["7", "24", "15.0", "2–3 y"],
      ["8", "25", "15.8", "3–4 y"],
      ["9", "27", "16.7", "4–5 y"],
      ["10", "28", "17.5", "5–6 y"],
      ["11", "29", "18.3", "6–7 y"],
      ["12", "30", "19.1", "7–8 y"],
      ["13", "32", "20.0", "8–9 y"],
      ["1", "33", "20.8", "9–10 y"],
      ["2", "34", "21.6", "10–11 y"],
      ["3", "35", "22.5", "11–12 y"],
    ],
  },
};

export const APPAREL = {
  men: {
    columns: ["Size", "India", "Chest (in)", "Waist (in)"],
    rows: [
      ["XS", "36", "34–36", "28–30"],
      ["S", "38", "36–38", "30–32"],
      ["M", "40", "38–40", "32–34"],
      ["L", "42", "40–42", "34–36"],
      ["XL", "44", "42–44", "36–38"],
      ["XXL", "46", "44–46", "38–40"],
      ["XXXL", "48", "46–48", "40–42"],
    ],
  },
  women: {
    columns: ["Size", "India", "Bust (in)", "Waist (in)", "Hip (in)"],
    rows: [
      ["XS", "32", "31–32", "24–25", "34–35"],
      ["S", "34", "33–34", "26–27", "36–37"],
      ["M", "36", "35–36", "28–29", "38–39"],
      ["L", "38", "37–39", "30–32", "40–42"],
      ["XL", "40", "40–42", "33–35", "43–45"],
      ["XXL", "42", "43–45", "36–38", "46–48"],
    ],
  },
  kids: {
    columns: ["Size", "Age", "Height (cm)"],
    rows: [
      ["XS", "2–3 y", "92–98"],
      ["S", "4–5 y", "104–110"],
      ["M", "6–7 y", "116–122"],
      ["L", "8–9 y", "128–134"],
      ["XL", "10–11 y", "140–146"],
      ["XXL", "12–14 y", "152–164"],
    ],
  },
};

// The size OPTIONS shown as tappable buttons in "my picks", per gender.
export const PICK_SIZES = {
  footwear: {
    men: ["6", "7", "8", "9", "10", "11", "12"],
    women: ["3", "4", "5", "6", "7", "8"],
    kids: ["6", "7", "8", "9", "10", "11", "12", "13", "1", "2", "3"],
  },
  apparel: {
    men: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    women: ["XS", "S", "M", "L", "XL", "XXL"],
    kids: ["XS", "S", "M", "L", "XL", "XXL"],
  },
};

// footwear | apparel — from a product/category slug (handles "footwear", "apparel",
// "sports-equipment" → none, etc.).
export function chartKindFor(category) {
  const c = String(category || "").toLowerCase();
  if (c.includes("foot")) return "footwear";
  if (c.includes("apparel") || c.includes("cloth")) return "apparel";
  return null;
}

// Best-guess gender from a product's department (Men | Women | Kids | Unisex).
export function genderFromDepartment(dep) {
  const d = String(dep || "").toLowerCase();
  if (d.includes("women") || d.includes("girl")) return "women";
  if (d.includes("kid") || d.includes("boy") || d.includes("infant") || d.includes("child")) return "kids";
  return "men"; // men / unisex / unknown
}

export function chartFor(category, gender) {
  const kind = chartKindFor(category);
  if (!kind) return null;
  const table = kind === "footwear" ? FOOTWEAR : APPAREL;
  return { kind, ...(table[gender] || table.men) };
}
